export default "__VITE_PUBLIC_ASSET__5511dcf9__"